import { OrderResponse } from 'api/accessexpressv3/schemas/OrdersSchemas';
import Loader from 'components/Loader';
import { Modal } from 'components/Modal/Modal';
import { GraniteButton } from 'components/V2/Button/GraniteButton';

export const DeleteOrderConfirmationDialog = ({
  isOpen,
  close,
  onConfirmation,
  dynamicProps,
  isLoading,
}: {
  isOpen: boolean;
  close: () => void;
  onConfirmation: (order?: OrderResponse) => void;
  dynamicProps?: OrderResponse;
  isLoading: boolean;
}) => (
  <Modal isVisible={isOpen} close={close} className="max-w-[624px]">
    <div className="space-y-12 rounded-t-lg bg-background-base-surface-2 p-8">
      <div className="space-y-2">
        <h1 className="text-content-base-default">
          Are you sure want to delete this draft?
        </h1>
        <p className="font-bold text-content-base-subdued">
          This action cannot be undone. Once deleted, this draft will be
          permanently removed.
        </p>
      </div>
      <div className="flex gap-5">
        <GraniteButton size="large" variant="secondary" onClick={close}>
          Cancel
        </GraniteButton>
        <GraniteButton
          size="large"
          variant="destructive"
          disabled={isLoading}
          onClick={() => {
            onConfirmation(dynamicProps);
          }}
        >
          Yes, delete draft {isLoading && <Loader width="w-4" height="h-4" />}
        </GraniteButton>
      </div>
    </div>
  </Modal>
);
